export function bytesToEncoded(bytes) {
    // Convert bytes to a binary string and then to base64
    const binaryString = Array.from(bytes)
        .map(byte => String.fromCharCode(byte))
        .join('');
    return window.btoa(binaryString);
}
